.kdx-anchor-links {
  .kdx-anchor-links-header {
    color: $gray-dark;
  }

  .kdx-anchor-links-body {
    min-height: 50px;
    background-color: $gray-lite;
    padding: 15px;

    .btn {
      margin: 5px 15px 5px 10px;
      padding: 6px 18px;
    }

    @include media-breakpoint-down(md) {

      .btn {
        margin-right: 0;
        display: block;
      }
    }
  }
}
